<template>
    <v-app id="app" style="overflow: auto !important; overflow-x: hidden !important; scrollbar-width: thin !important">
        <alertbox style="z-index: 999999 !important" />
        <confirmation style="z-index: 999999 !important" />
        <datePicker style="z-index: 999999 !important" />
        <comment style="z-index: 999999 !important" />
        <location></location>
        <fsdialog style="z-index: 99999 !important" />
        <pudialog style="z-index: 999999 !important" />
        <confirmbox style="z-index: 999999 !important" />

        <qrCodeGeneratorDialog></qrCodeGeneratorDialog>
        <!-- App Top Bar - Mobile -->
        <v-app-bar
            app
            color="secondary"
            height="64"
            style="z-index: 99999 !important"
            dark
            clipped-left
            class="ma-0 py-0 px-3 pr-2 noprint"
            v-if="$vuetify.breakpoint.smAndDown && GET_currentUser !== null"
        >
            <v-btn icon class="white--text" @click.native="openMobileMenu()">
                <v-icon class="text-h5">icons8-menu</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title class="d-flex text-center">
                <div><v-img @click="MIX_goHome()" height="50" width="200" contain position="left" :src="require('@/assets/tfw_logo.png')" /></div>
            </v-toolbar-title>
            <!-- <h3  class="ml-5 font-weight-thin">{{ page.title }} <v-icon>mdi-menu-right</v-icon><span class="font-weight-bold">{{ page.subtitle }}</span> ({{ $vuetify.breakpoint.name }} {{ $vuetify.breakpoint.width }} )</h3> -->
            <v-spacer></v-spacer>
            <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="lighttext">icons8-male-user</v-icon>
                    </v-btn>
                </template>
                <mobile-menu-list />
            </v-menu>
            <!-- <v-btn icon class="white--text" @click.native="MIX_go('/')">
        <v-icon class="text-h5">icons8-home</v-icon>
      </v-btn> -->
            <!--language-selector/-->
        </v-app-bar>
        <!-- App Top Bar - Desktop / Tablet -->
        <v-app-bar
            app
            color="secondary"
            dark
            clipped-left
            class="ma-0 py-0 pl-0 pr-3 noprint elevation-0"
            style="z-index: 99999 !important"
            v-if="$vuetify.breakpoint.mdAndUp && GET_currentUser !== null"
        >
            <v-toolbar-title>
                <v-img
                    v-if="GET_breadcrumbs[0].name === 'Home'"
                    @click="MIX_goHome()"
                    height="55"
                    width="235"
                    position="left"
                    :src="require('@/assets/tfw_logo.png')"
                />
                <v-img v-else @click="MIX_go('/')" height="55" width="55" position="left" :src="require('@/assets/tfw_logo.png')" />
            </v-toolbar-title>
            <!-- <h3 class="ml-5 font-weight-thin"><span v-html="GET_breadcrumbs"></span></h3>
       -->

            <h4 v-if="GET_currentUser !== null && GET_breadcrumbs[0].name !== 'Home'" class="ml-5 font-weight-thin">
                <span v-for="(breadcrumb, index) in GET_breadcrumbs" :key="index">
                    <span class="font-weight-bold" v-if="index === GET_breadcrumbs.length - 1">
                        <!-- LAST BREADCRUMB -->
                        <router-link v-if="breadcrumb.path !== undefined" class="white--text nounderline" :to="breadcrumb.path">{{
                            breadcrumb.name
                        }}</router-link>
                        <span v-if="breadcrumb.path === undefined" class="white--text nounderline">{{ breadcrumb.name }}</span>
                    </span>
                    <span v-else>
                        <router-link v-if="breadcrumb.path !== undefined" class="white--text nounderline" :to="breadcrumb.path">{{
                            breadcrumb.name
                        }}</router-link>
                        <span v-if="breadcrumb.path === undefined" class="white--text nounderline">{{ breadcrumb.name }}</span>
                        <v-icon>mdi-menu-right</v-icon>
                    </span>
                </span>
            </h4>
            <v-spacer></v-spacer>
            <!-- <div class="d-flex align-center purple--text">
        <v-select @change="ACT_simulatedUserType(userType)" v-model="userType" :items="userTypes" item-text="text" item-value="value"  dense hide-details  clearable label="Type Simulation" class="mx-1"></v-select>
        <v-select @change="ACT_simulatedUserRole(userRole)" v-model="userRole" :items="userRoles" item-text="text" item-value="value"  dense hide-details  clearable label="Role Simulation" class="mx-1"></v-select>

      </div> -->
            <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="lighttext">icons8-male-user</v-icon>
                    </v-btn>
                </template>
                <mobile-menu-list />
            </v-menu>
            <!-- <div v-if="GET_currentUser" >
        <span class="purple--text" v-if="['DA'].includes(GET_currentUser.userLevel)">{{ GET_currentUser.userLevel}} | {{ $vuetify.breakpoint.name }} | {{ $vuetify.breakpoint.width }} </span>
      </div> -->
            <!-- LANGUAGE SELECTOR -->
            <!--language-selector/-->
            <!-- BURGER MENU BUTTON -->
            <!-- LOG OUT BUTTON -->
            <!-- <v-icon
        v-if="$store.getters.GET_currentUser != null"
        class="white--text"
        @click="logout()"
        >icons8-fire-exit</v-icon
      > -->
        </v-app-bar>
        <!--/v-app-bar-->
        <!-- Vertical Navigation -->
        <v-navigation-drawer
            permanent
            hide-overlay
            expand-on-hover
            class="primary noprint"
            style="z-index: 99998 !important"
            app
            clipped
            ref="navigationDrawer"
            v-if="$vuetify.breakpoint.mdAndUp && GET_currentUser !== null"
        >
            <menuList />
        </v-navigation-drawer>

        <!-- Horizontal Navigation -->
        <v-banner app sticky class="pa-0 ma-0" style="z-index: 99999 !important" v-if="$vuetify.breakpoint.smAndDown && GET_currentUser !== null">
            <v-row no-gutters>
                <v-col cols="12" xs="12">
                    <v-tabs
                        icons-and-text
                        fixed-tabs
                        hide-overlay
                        class=""
                        v-model="menutab"
                        height="75"
                        background-color="primary"
                        dark
                        color="white"
                        active-class="primary"
                        hide-slider
                    >
                        <v-tab v-for="(item, index2) in menu" :key="index2" :to="item.path" class="pt-2 white--text">
                            <span class="caption font-weight-bold">{{ item.name }}</span>
                            <v-icon class="navicons white--text">{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                </v-col>
                <v-col cols="6" xs="6"></v-col>
            </v-row>
        </v-banner>

        <progressbar />

        <appupdate style="z-index: 999999 !important" />

        <!-- Mobile Full Screen Menu -->
        <v-dialog v-model="GET_mobileNav" style="z-index: 999999999 !important" fullscreen transition="slide-x-transition">
            <v-card class="primary backgreen">
                <v-card-title class="secondary white--text pl-2 pr-0 py-2" style="height: 64px !important">
                    <v-btn icon class="white--text" @click.native="openMobileMenu()">
                        <v-icon class="text-h5">icons8-menu</v-icon>
                    </v-btn>
                    <div class="ml-3">Menu</div>
                    <v-spacer></v-spacer>
                    <div class="text-right">
                        <appbutton icon="icons8-multiply" type="secondary" iconclass="white--text" @click.native="MIX_mobileNav(false)" />
                    </div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="primary noprint">
                    <menuList />
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-main
            class="appbackground"
            :style="$vuetify.breakpoint.mdAndUp && GET_currentUser !== null ? { padding: mainPadding, transition: 'padding 0.3s ease' } : ''"
        >
            <v-container class="ma-0 pa-0 d-flex align-start fill-height" fluid>
                <!-- GET_currentUser = <pre>{{ GET_currentUser }}</pre><br />
          GET_currentUserData = <pre>{{ GET_currentUserData}}</pre> -->
                <transition
                    name="custom-classes-transition"
                    enter-active-class="animate__animated animate__fadeIn animate__faster"
                    leave-active-class="animate__animated animate__fadeOut animate__faster"
                    mode="out-in"
                >
                    <router-view />
                </transition>
            </v-container>
            <!--start of ACCESS-CODE-OVERLAY-->
            <v-overlay v-if="dialogLogin === true" :opacity="1" color="vindicoPurple">
                <v-dialog v-if="!authSuccess" v-model="dialogLogin" persistent style="z-index: 3000 !important" width="500">
                    <v-card flat class="login" color="vindicoPurple">
                        <v-card-title class="justify-center">
                            <v-img height="50" contain width="50%" :src="require('@/assets/vlogo-white.png')" />
                        </v-card-title>
                        <v-divider class="white"></v-divider>
                        <v-card-text class="mt-2 mb-0 pb-0">
                            <!-- <p class="headline white--text text-left font-weight-thin my-0 py-0" >Vindico Preview</p> -->
                            <p class="body-1 white--text my-0 py-2">Please enter the access code you received in order to proceed to the preview.</p>
                            <!-- ACCESS-CODE-INPUT-->
                            <v-text-field
                                label="Enter Access Code"
                                v-model.trim="accessCode"
                                dark
                                filled
                                type="password"
                                v-on:keyup.enter="enterAccessCode()"
                            ></v-text-field>
                            <!-- start of ERROR-MESSAGE-->
                            <v-row v-if="authCode === 0" class="justify-center ma-0 pa-0">
                                <transition name="custom-classes-transition" enter-active-class="animated flash">
                                    <span :class="{ 'error--text': !authSuccess }" class="subtitle1 font-weight-bold">{{ authMessage }}</span>
                                </transition>
                            </v-row>
                            <!-- end of ERROR-MESSAGE-->
                        </v-card-text>
                        <v-card-actions class="justify-center pt-0 mt-0 pb-4">
                            <!-- ENTER-ACCESS-CODE-BUTTON-->
                            <v-btn class="white vindicoPurple--text" large @click="enterAccessCode()">Enter</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-overlay>
            <!--end of ACCESS-CODE-OVERLAY-->
        </v-main>
    </v-app>
</template>

<script>
import LanguageSelector from './components/structural/language-selector.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import MobileMenuList from './components/structural/mobile-menu-list.vue'
export default {
    name: 'App',
    components: {
        LanguageSelector,
        MobileMenuList
    },
    data() {
        return {
            // Data properties
            currentUser: [],
            menutab: 5,
            LATEST_VERSION: '1.3.3',
            showInstallBanner: false,
            menu: [
                // { name: "Home", icon: "icons8-home", path: `/` },
                { name: 'To Do', icon: 'icons8-todo-list', path: `/todos/` },
                { name: 'Projects', icon: 'icons8-project', path: `/projects/` },
                { name: 'Incidents', icon: 'icons8-form', path: `/concerns/` }
            ],
            showPageElements: false, // hide menu etc. when there's no user logged in
            mobileBurgerMenu: false, //mobile menu
            // * ACCESS CODE VARIABLES
            // TODO - change access password
            accessPassword: 'Vindico2021!', // ? ACCESS PASSwORD
            accessCode: '', // TODO remove before go live // user input code
            dialogLogin: false, // login dialog
            authSuccess: false, // TODO change back to false before go live // * when true - closes the overlay
            authMessage: null, // message displayed to user
            authCode: null, // * 1 for correct password, 0 for incorrect

            userTypes: [],
            userType: '',
            userRoles: [],
            userRole: '',

            // Add the drawer mini state tracking
            isDrawerMini: true,
            drawerObserver: null
        }
    },
    computed: {
        mainPadding() {
            // Only apply custom padding for desktop with a logged in user
            if (this.$vuetify.breakpoint.mdAndUp && this.GET_currentUser !== null) {
                // For mini drawer (56px left padding)
                if (this.isDrawerMini) {
                    return '64px 0px 0px 56px'
                }
                // For expanded drawer (56px left padding)
                return '64px 0px 0px 56px'
            }

            // Default padding (let Vuetify handle it for mobile)
            return null
        },
        ...mapState({
            page: state => state.page
        }),
        ...mapGetters(['GET_breadcrumbs', 'GET_mobileNav', 'GET_lookupValues', 'GET_currentUser', 'GET_appUpdate'])
    },
    watch: {
        // // TODO DISABLED BY RYAN ON 24-Feb-2021
        currentUser: {
            handler: function() {
                this.$store.commit('MUT_currentUser', this.currentUser)
                // console.log(
                //   "currentUser: " + JSON.stringify(this.currentUser, null, 2)
                // );
            },
            deep: true
        },
        GET_currentUser: {
            handler: function() {
                if (this.GET_currentUser != null) {
                    this.userType = this.GET_currentUser.userType
                    this.userRole = this.GET_currentUser.userRole
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapActions(['ACT_simulatedUserType', 'ACT_simulatedUserRole', 'ACT_currentUser']),

        // Add method to set up drawer observer
        setupDrawerObserver() {
            // Wait for the drawer to be mounted
            this.$nextTick(() => {
                // Get the drawer element
                const drawerEl = document.querySelector('.v-navigation-drawer')

                if (drawerEl) {
                    // Create a mutation observer to watch for class changes
                    this.drawerObserver = new MutationObserver(mutations => {
                        mutations.forEach(mutation => {
                            if (mutation.attributeName === 'class') {
                                // Check if mini variant class is present
                                this.isDrawerMini = drawerEl.classList.contains('v-navigation-drawer--mini-variant')
                                console.log('Drawer mini state:', this.isDrawerMini)
                            }
                        })
                    })

                    // Start observing the drawer element
                    this.drawerObserver.observe(drawerEl, { attributes: true })

                    // Initial check in case class is already set
                    this.isDrawerMini = drawerEl.classList.contains('v-navigation-drawer--mini-variant')
                }
            })
        },

        openMobileMenu() {
            this.MIX_mobileNav(true)
            this.mobileBurgerMenu = true
        },
        enterAccessCode() {
            // * Access code validation
            var v = this
            if (this.accessCode === this.accessPassword) {
                v.authSuccess = true // * close the overlay
                v.authCode = 1 // * success code
                v.authMessage = 'The access code was correct'
                v.accessCode = null
            } else {
                v.authSuccess = false // ! keep the overlay open
                v.authCode = 0 // ! error code
                v.authMessage = 'The access code you have entered is incorrect'
            }
        },
        logout() {
            this.$firebase.auth.signOut().then(() => {
                this.showPageElements = false
                this.$router.push('/login').catch(err => {
                    // console.log("Route error: " + err);
                })
                this.ACT_currentUser(null)
            })
        },

        // Clean up the observer on component destroy
        cleanupDrawerObserver() {
            if (this.drawerObserver) {
                this.drawerObserver.disconnect()
                this.drawerObserver = null
            }
        }
    },
    async mounted() {
        var t = this
        // do something based on the navigation type...
        switch (performance.navigation.type) {
            case 0:
                t.MIX_closeView()
                t.MIX_mobileNav(false)
                break
            case 1:
                t.MIX_closeView()
                t.MIX_mobileNav(false)
                break
            case 2:
                t.MIX_closeView()
                t.MIX_mobileNav(false)
                break
            case 255:
                break
        }

        if (this.GET_currentUser != null) {
            this.userType = this.GET_currentUser.userType
            this.userRole = this.GET_currentUser.userRole
        }

        await t.MIX_lookupValues() // LOAD LOOKUP VALUES
        t.userTypes = await t.GET_lookupValues('USERTYPES')
        t.userRoles = await t.GET_lookupValues('USERROLES')

        var breadcrumbs = []
        breadcrumbs.push({ name: `Home`, path: `/` })
        this.MIX_breadcrumbs(breadcrumbs)

        // Set up the drawer observer after Vue has updated the DOM
        this.setupDrawerObserver()
    },
    beforeDestroy() {
        // Clean up the observer to prevent memory leaks
        this.cleanupDrawerObserver()
    }
}
</script>

<style>
html,
body {
    height: 100%;
    overflow: hidden;
    touch-action: none;
}

/* width */
::-webkit-scrollbar {
    width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #212121;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #212121;
}
#app {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

.nounderline {
    text-decoration: none !important;
}

pre {
    overflow-x: auto;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    font-size: 13px !important;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}
.v-toolbar__content {
    padding: 0px !important;
    padding-left: 1px !important;
    padding-right: 7px !important;
}
#nav a.router-link-exact-active {
    color: #42b983;
}
.navicons {
    font-size: 28px !important;
    font-weight: bold !important;
}

.borderred {
    border: 2px solid red !important;
}
.bordergreen {
    border: 2px solid green !important;
}
.borderblue {
    border: 2px solid blue !important;
}
.backred {
    background-color: rgba(255, 0, 0, 0.5) !important;
}
.backgreen {
    background: rgba(0, 255, 0, 0.5) !important;
}
.backblue {
    background: rgba(0, 0, 255, 0.5) !important;
}

.contenttitle {
    height: 70px !important;
}

.tabledata {
    z-index: 1 !important;
}

.copyright {
    /* background: purple !important; */
    z-index: 0 !important;
    position: fixed;
    bottom: 10px;
    margin-left: 8px !important;
    width: calc(100% - 90px) !important;
}

/*
.v-btn__content {
  font-size: 5px !important;
} */

.sticky {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
}

.v-banner__wrapper {
    padding: 0px !important;
    margin: 0px !important;
}
.v-banner__content {
    padding: 0px !important;
    margin: 0px !important;
}

.horizontalnav {
    z-index: 999 !important;
}

.appbar {
    z-index: 9999999 !important;
}

.border-left-grey {
    border-left: 3px solid #cdcdcd !important; /*//#DFDFDF; /*E0E0E0*/
}
.border-top-grey {
    border-top: 2px solid #cdcdcd !important;
}

.dashcard {
    display: flex !important;
    flex-direction: column !important;
    align-items: center;
    justify-content: center;
    height: 115px !important;
    background-color: white !important;
    border-radius: 5px !important;
}
.dashvalue {
    height: 75px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center;
    justify-content: center;
}

/* Show Pointer */
.pointer {
    cursor: pointer;
}
/* No Text Select */
.noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently */
}

.appclosebar {
    min-height: 50px !important;
}

/* // * FORM RELATED STYLES */
.disabled {
    pointer-events: none;
    cursor: not-allowed;
}

.tablecard {
    border-radius: 5px !important;
    width: 100% !important;
    height: 100px !important;
}

.expandtofill {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
    /* background: #ffffff !important; */
}
/* CONTENT START */
</style>

<style lang="sass">
@import '~vuetify/src/styles/styles.sass'

@media #{map-get($display-breakpoints, 'md-and-up')}
  .authpage
      display: flex
      align-items: center
      justify-content: center
      width: 100vw !important
      height: 100vh !important
  .authblock
      width: 500px
  .contentstart
      margin-top: 20px !important

@media #{map-get($display-breakpoints, 'xs-only')}
  .contentstart
      margin-top: 50px !important
  .bottomnav
      width: 100% !important
  .submenu
      z-index: 100 !important
      position: fixed !important
      top: 131px !important
      width: 100% !important
  .copyright
      width: calc(100% - 25px) !important
      bottom:0px !important
  .authblock
      width: 100vw
</style>
